// extracted by mini-css-extract-plugin
export default {"button":"Button_button__mHSnF","red":"Button_red__sIYGj","white":"Button_white__6eb-A","loading":"Button_loading__gFFMH","none":"Button_none__+GhyV"};